:host {
    width: 100%;

    ti-card {
        margin-top: $polaris-space-6;
    }
    .new-badge {
        margin-bottom: .5rem;
        color: #c00;
        font-size: 12px;
        line-height: 24px;
        font-weight: 500;
        text-transform: uppercase;
        text-decoration: none;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            left: 5px;
            top: 5px;
            border-top: 1px solid $polaris-color-grey7;
            width: 6px;
        }
    }

    a {
        color: $polaris-color-teal5;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
    .ti-part-matches {

        h6 {
            font-size: $polaris-font-size-2;
            font-weight: $polaris-font-weight-bold;
            color: $polaris-color-grey8;
            margin: 0 0;
        }


        &-family {
            margin-top: $polaris-space-5;
            @media only screen and (max-width: 768px)  {
                margin-bottom: $polaris-space-2;
            }
        }

        &-label {
            display: flex;
            flex-wrap: nowrap;
            font-size: $polaris-font-size-1;
            text-transform: uppercase;
            line-height: $polaris-line-height-1;
            color: $polaris-color-grey7;
            margin: $polaris-space-1 0;
            &:hover {
                color: $polaris-color-grey7;
            }
        }
        .ti-pagination-row {
            display: block;
            .ti-pagination-more {
                float: left;
                padding: 0.6em 0;
                margin-top: $polaris-space-2;
            }
        }

        @media only screen and (max-width: 768px)  {
            margin: -8px
        }


    }
    .ti-part-matches-list {
        width: 100%;

    }
    .ti-part-matches-list-row {
        border-bottom: 1px solid #e8e8e8;
        padding: 0.6em 0;
        line-height: $polaris-line-height-2;
        &.ti-part-matches-number {
            white-space: nowrap;
        }

        .ti-part-matches-description {
            position: relative;
            padding-left: 20px;
            &::after {
                content: "";
                border-top: 1px solid #555;
                width: 10px;
                position: absolute;
                top: 8px;
                left: 5px;
            }
        }
    }




    .ti-part-matches-status {
        white-space: nowrap;
    }
    // @media all and (-ms-high-contrast: none),
    // (-ms-high-contrast: active) {
    //     ti-multicolumn-list-row {
    //         padding-left: 100px;
    //     }
    //     ti-multicolumn-list-cell {
    //         padding: .6em !important;
    //     }
    // }
    .ti-part-matches-expander {
        cursor: pointer;
        color: $polaris-color-teal5;
        ti-svg-icon {
            margin-left: $polaris-space-icon;
            transition: transform .15s $polaris-animation-easing-smooth;
        }
        &.collapsed {
            ti-svg-icon {
                transform: rotate(180deg);
            }
        }
    }

}
